import { render } from "./CallTaxi.vue?vue&type=template&id=3bfe1e02&scoped=true"
import script from "./CallTaxi.vue?vue&type=script&lang=js"
export * from "./CallTaxi.vue?vue&type=script&lang=js"

import "./CallTaxi.vue?vue&type=style&index=0&id=3bfe1e02&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfe1e02"]])

export default __exports__